/**
 * Words this application uses everywhere.
 *
 * Keyed by id rather than by the English text, so the wording can be fixed without silently
 * un-translating every screen that uses it. Anything with a number in it is a FUNCTION, because the
 * number does not have to land in the same place in another language.
 */
export default {
  language: 'Language',
  save: 'Save',
  saving: 'Saving…',
  cancel: 'Cancel',
  close: 'Close',
  loading: 'Loading…',
  search: 'Search',
  edit: 'Edit',
  remove: 'Remove',
  saved: 'Saved',
  somethingWentWrong: 'Something went wrong. Try again.',
  required: 'Required',
}
